import loadable from "@loadable/component";
import appWysiwygComponents from "theme/modules/WysiwygV2/appWysiwygComponents";

const DefaultWysiwyg = loadable(() => import("./DefaultWysiwyg"));

const typenameMap = {
  MagentoWysiwyg: loadable(() => import("./MagentoWysiwyg/MagentoWysiwyg")),
  ...appWysiwygComponents,
};

const getWysiwygComponent = (type) => {
  return typenameMap[type] || DefaultWysiwyg;
};

export default getWysiwygComponent;
